import React from "react";
import { HotelFilterPopover } from "./HotelFilterPopover";
import { ExportFilterPopover } from "./ExportFilterPopover";
import { PartnerPeriodSelector } from "@/components/pages/guesteria-partners/components/PartnerPeriodSelector";

type HotelOption = {
  id: string;
  name: string;
  logoId?: string | null;
  logoClassName: string;
  logoLetter: string;
};

type GuesteriaPartnersRevenueFiltersProps = {
  hotelOptions: HotelOption[];
  selectedHotels: string[];
  selectedExportFormat: "CSV" | "Excel" | null;
  onHotelsApply: (hotels: string[]) => void;
  onExportApply: (format: "CSV" | "Excel" | null) => void;
  canExport: boolean;
};

// Task 0038 (owner, 2026-09-30): the date range control is the one shared
// `PartnerPeriodSelector` now (presets + custom + "By service date"),
// state in the URL — this component no longer owns any date-range props.
export const GuesteriaPartnersRevenueFilters = ({
  hotelOptions,
  selectedHotels,
  selectedExportFormat,
  onHotelsApply,
  onExportApply,
  canExport,
}: GuesteriaPartnersRevenueFiltersProps): React.JSX.Element => {
  return (
    <div className="flex items-center justify-between rounded-md bg-white py-2">
      <div className="flex items-center gap-2">
        <HotelFilterPopover
          options={hotelOptions}
          selectedHotels={selectedHotels}
          onApply={onHotelsApply}
        />
        <PartnerPeriodSelector />
      </div>
      {canExport ? (
        <ExportFilterPopover
          selectedFormat={selectedExportFormat}
          onApply={(format) => {
            onExportApply(format);
          }}
        />
      ) : null}
    </div>
  );
};
